import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/session`, {params})
    },
    remove(id) {
        return Vue.axios.get(`/session/remove/${id}`)
    },

}
